/* eslint-disable @typescript-eslint/naming-convention */

import { OnboardingBusinessConfigScheduleDataProps } from '../models/BusinessConfig.model';

export type WizardGetTemplatesApiRespProps = BusinessTemplate[];

export interface BusinessTemplate {
  id: string;
  template_name: string;
  template_tags: string;
  template_vertical: string;
}

export interface IGetBusinessImagesApiRespoProps {
  images: any[];
}

export interface IGetSiteImagesProps {
  feature_image: string;
  about_image: string;
  spotlight_image: string;
  contact_image: string;
  logo_image: string;
  gallery: any[];
}

export interface IWizardCreateUserPayloadProps {
  name: string;
  last_name: string;
  language: string;
  country_code: string;
  email: string;
  phone: string;
  password: string;
  confirm_password: string;
  brand_id: number;
  partner_id: number;
  platform_login?: string;
  third_id?: string;
}

export interface ICreateUserProps {
  brand_id: number;
  name: string;
  last_name: string;
  email: string;
  phone: string;
  country_code: string;
  zipcode: string;
  state: string;
  locality: string;
  settlement: string;
  settlement_id: string;
  street_address: string;
  address_ext_number: string;
  address_int_number: string;
  //language: string;
}

export interface IWizardCreateUserApiRespProps {
  token: string;
}

export type BusinessGetApiRespProps = Omit<
  IBusinessAllProps,
  AdditionalBusinessData
>;

export type BusinessUpdatePayloadProps = Partial<IBusinessAllProps>;

export type BusinessUpdateApiRespProps = IBusinessAllProps;

interface IBusinessAllProps {
  BUSINESS_CONFIG_GMB_STATUS?: true | false;
  BUSINESS_CONFIG_NOTIFICATIONS?: true | false;
  BUSINESS_CONFIG_PAYMENTS?: true | false;
  BUSINESS_CONFIG_SCHEDULE?: true | false;
  BUSINESS_CONFIG_SERVICES?: true | false;
  BUSINESS_CONFIG_SOCIAL?: true | false;
  BUSINESS_CONFIG_WEBSITE?: true | false;
  BUSINESS_REGISTRATION?: true | false;
  GMB_CREATE_OR_SYNC?: true | false;
  USER_HAS_GMB_ACCOUNT?: true | false;

  BOOKING_SYNC?: true | false;
  ALLOW_STORE?: true | false;
  ALLOW_SITE?: true | false;
  ALLOW_CRM?: true | false;
  ALLOW_FOOD_MENU?: true | false;
  ALLOW_FACEBOOK?: true | false;
  ALLOW_BOOKING?: true | false;
  ALLOW_GMB?: true | false;
  ALLOW_VENTASCLICKPAY?: true | false;
  ALLOW_DIRECTORY?: true | false;

  business_id: string;
  name: string; //the user name

  // BUSINESS CREATION DATA
  business_name: string;
  business_email: string;
  email_user: string;
  mobile_phone: string;
  phone: string;
  street_address: string;
  address_ext_number: string;
  address_int_number: string;
  latitude: string | number;
  longitude: string | number;
  zipcode: string;
  country_code: string;
  countryCode?: string;
  country_calling_code: string;
  language_code?: string;
  languageCode?: string;
  language?: string;
  third_id?: string;
  suscriptionClient?: any;
  color_theme_id?: any;

  // BUSINESS ADDITIONAL INFO
  // - SERVICES
  products: string[];
  // - SCHEDULE
  hours_of_operation: OnboardingBusinessConfigScheduleDataProps;
  hours_of_operation_notes: string;
  schedule?: OnboardingBusinessConfigScheduleDataProps;
  // - SOCIAL NETWORKS
  facebook_url: string;
  twitter_url: string;
  instagram_url: string;
  tiktok_url?: string;
  // - PAYMENT METHODS
  payment_methods: string[];

  // WEBSITE DATA
  business_description: string;
  images: {
    logo_image?: string;
    about_image?: string;
    gallery?: { index: number; image: string }[];
    contact_image?: string;
    feature_image?: string;
    spotlight_image?: string;
  };

  // CREATION RESPONSE
  wizard_finished_at: string;
  site_url: string;
  sites: any[];

  // ADDITIONAL DATA
  template_id: string | number;
  template_description: string;
  full_address: string;
  settlement: string; //colonia
  locality: string; //Municipio
  state: string; // ciudad/estado
  country: string;
  extra_site_url: string;

  // ECWID DATA
  ecwic_sync?: boolean;
  ventasclickpay_sync?: boolean;
  brand?: string;
  brand_id?: number
  score?: boolean;
  stars?: number;
  review?: string;
  external_subscription_id?: any;
}

type AdditionalBusinessData =
  | 'template_id'
  | 'settlement'
  | 'locality'
  | 'state'
  | 'country'
  | 'extra_site_url';

export interface IWizardUserPersonalInfoResponse {
  id: string;
  domain: string;
  name: string;
  email: string;
  mobile_phone: string;
  phone: string;
  created_at: string;
  wizard_finished_at: string;
  email_invitation_sent_at: string;
}

export interface IWizardUserBusinessInfoResponse {
  business_id: string;
  name: string;
  wizard_finished_at: string;
  street_address: string;
  business_name: string;
  email: string;
  mobile_phone: string;
  phone: string;
  business_rfc: string;
  business_type_rfc: string;
  facebook_url: string;
  twitter_url: string;
  instagram_url: string;
  business_description: string;
  address_ext_number: string;
  address_int_number: string;
  latitude: string;
  longitude: string;
  gmb_category_id: string;
  gmb_category_name: string;
  zipcode: string;
  settlement: string;
  settlement_id: string;
  township_id: string;
  township: string;
  state_id: string;
  business_sub_category_name: string;
  business_sub_category_id: string;
  state: string;
  sitebuilder_state_code: string;
  sitebuilder_template_id: string;
  url_default_img: string;
  business_category_name: string;
  business_category_id: string;
}

export interface IWizardUserBusinessAdditionalInfoResponse {
  schedule: {
    monday_start_time: string;
    monday_end_time: string;
    tuesday_start_time: string;
    tuesday_end_time: string;
    wednesday_start_time: string;
    wednesday_end_time: string;
    thursday_start_time: string;
    thursday_end_time: string;
    friday_start_time: string;
    friday_end_time: string;
    saturday_start_time: string;
    saturday_end_time: string;
    sunday_start_time: string;
    sunday_end_time: string;
    open_247: '0' | '1';
    additional_info: string;
    no_hours: '0' | '1';
  };
  payment_methods: [];
  products: {
    id: '2342';
    name: 'de algodon';
  }[];
  shipment: string[];
}

export interface ISearchClientResponse {
  business_id: string;
  name: string;
  wizard_finished_at: string;
  street_address: string;
  business_name: string;
  email: string;
  mobile_phone: string;
  phone: string;
  facebook_url: string;
  twitter_url: string;
  instagram_url: string;
  business_description: string;
  address_ext_number: string;
  address_int_number: string;
  latitude: string;
  longitude: string;
}

export interface IDeleteImageFormProps {
  //business_id: number;
  container: 'logo' | 'about' | 'gallery' | 'feature' | 'contact' | 'spotlight';
  index?: number;
  url_img: string;
}

export interface IDeleteImageResponse {
  img: string;
  msj: string;
}

export interface BusinessSiteFields {
  feature_text?: string;
  feature_sub_text?: string;
  feature_button_1_text?: string;
  feature_button_2_text?: string;
  about_title_text?: string;
  about_text?: string;
  product_title_text?: string;
  spotlight_title_text?: string;
  spotlight_subtitle_text?: string;
  carousel_title_text?: string;
  contact_title_text?: string;
  map_title_text?: string;
}

